<template>
  <payment-type-form v-if="model"
                     :data="model"
                     :title="$t('thirdParties.edit.title', { name: model ? model.name : ''})"
                     :submit-loading="submitLoading"
                     @submit="onSubmit">
  </payment-type-form>
</template>
<script>
import PaymentTypeForm from './PaymentTypeForm'
import PaymentTypeService from 'src/services/PaymentTypeService'

export default {
  components: {
    PaymentTypeForm,
  },
  data () {
    return {
      submitLoading: false,
      model: null,
    }
  },
  methods: {
    async getData () {
      let {data} = await PaymentTypeService.getById(this.$route.params.id)
      this.model = data
    },
    async onSubmit (data) {
      try {
        this.submitLoading = true
        await PaymentTypeService.update(data.id, data)
        this.$router.push('/settings/payment-types')
      } finally {
        this.submitLoading = false
      }
    },
  },
  watch: {
    '$store.state.config.textLanguage' () {
      this.getData()
    },
  },
  async created () {
    await this.getData()
  }
}
</script>
<style>
</style>
